import { render, staticRenderFns } from "./TrivestButton.vue?vue&type=template&id=46dc06a2&scoped=true"
import script from "./TrivestButton.vue?vue&type=script&lang=ts"
export * from "./TrivestButton.vue?vue&type=script&lang=ts"
import style0 from "./TrivestButton.vue?vue&type=style&index=0&id=46dc06a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dc06a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
